import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import * as APIModels from "../../../models";
import moment from "moment";
import {
    QueueService,
    SubmissionService,
} from "../../../services/SubmissionService";
import {
    DoubleFileStatus,
    DoubleFileStatusDetailedResponse,
} from "../../../models/swagger/generated-submission-service";
import GenericModal from "../../../components/shared/modals/GenericModal";

export interface QueueDetailRowProps {
    submission: APIModels.QueuedSubmission;
}

export default function QueueDetailRow({
    submission,
    filter,
    state,
    color,
}: {
    submission: APIModels.QueuedSubmission;
    filter?: string;
    state?: string;
    color?: string;
}) {
    const processHold = (submissionId: string) => {
        SubmissionService.cancel({ submissionId, body: {} }).then(
            (resp) => {
                if (resp.successful) {
                    window.location.href =
                        "/efile?submissionId=" + submission.id;
                } else {
                    window.location.href = "/queue";
                }
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };
    const cancel = (submissionId: string) => {
        SubmissionService.cancel({ submissionId, body: {} }).then(
            (resp) => {
                window.location.reload();
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };

    const sync = (submissionId: string) => {
        SubmissionService.sync({ submissionId }).then(
            (resp) => {
                window.location.reload();
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const aiPopulate = (submissionId: string) => {
        SubmissionService.aiPopulate({ submissionId }).then(
            (resp) => {
                console.log("sent to server");
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const checkDoubleFile = (submissionId: string) => {
        checkDoubleFileLog(submissionId, null);
        SubmissionService.checkDoubleFile({
            submissionId: submissionId,
        }).then(
            (resp) => {
                checkDoubleFileLog(null, resp);
                setStatus(resp.data ?? {});
            },
            (err) => {
                console.log(err);
            }
        );
    };

    const hide = (submissionId: string) => {
        QueueService.hide({ submissionId, body: {} }).then(
            (resp) => {
                window.location.reload();
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const deleteEfmeSubmit = (submissionId: string) => {
        QueueService.deleteEfmeSubmit({ submissionId }).then(
            (resp) => {
                alert("Cleared Submission Data for:" + submissionId);
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const reloadCase = (submissionId: string) => {
        QueueService.reloadCase({ submissionId }).then(
            (resp) => {
                window.location.reload();
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const shareCliqEfile = async (submissionId: string) => {
        const shareable = `https://v5.efilemadeeasy.com/redirect/${submissionId}&filter=available&state=`;

        ("/:submissionId");
        if (!navigator.clipboard) {
            throw new Error("Browser does not have support for copying text!");
        }

        await navigator.clipboard.writeText(shareable);
    };

    const shareCliqSubmissionStatus = async (submissionId: string) => {
        const shareable = `https://v5.efilemadeeasy.com/reporting/submission/${submissionId}`;
        if (!navigator.clipboard) {
            throw new Error("Browser does not have support for copying text!");
        }

        await navigator.clipboard.writeText(shareable);
    };

    const actionButton = (submissionId: string, status: string) => {
        if (status == "Parsed") {
            return (
                <a
                    className="btn btn-primary"
                    href={`/efile?submissionId=${submissionId}&filter=${
                        filter ?? ""
                    }&state=${state ?? ""}`}
                >
                    Process
                </a>
            );
        } else if (status == "Hold") {
            return (
                <button
                    onClick={() => processHold(submissionId)}
                    className="btn btn-warning"
                >
                    Process Hold
                </button>
            );
        } else if (status == "PreProcess") {
            return (
                <a
                    className="btn btn-primary"
                    href={`/preprocess?submissionId=${submissionId}&filter=${
                        filter ?? ""
                    }&state=${state ?? ""}`}
                >
                    Split
                </a>
            );
        } else {
            return (
                <button
                    onClick={() => cancel(submissionId)}
                    className="btn btn-danger"
                >
                    Cancel
                </button>
            );
        }
    };

    const ColoredRow = (props: { color: string | undefined }) => {
        const color = props.color;
        if (color === "yellow") {
            return (
                <tr style={{ background: "#f9faaf" }}>
                    <td>
                        {actionButton(
                            submission.id ?? "",
                            submission.statusDescription ?? ""
                        )}
                    </td>
                    <td>{submission.statusDescription}</td>
                    <td>{submission.legacyID || submission.id}</td>
                    <td>
                        {submission.filename}
                        <br />
                        {submission.statusReason}
                    </td>
                    <td>
                        {moment
                            .utc(submission.uploadedDateTime)
                            .local()
                            .format("MMMM Do YYYY, h:mm:ss a")}
                    </td>
                    {submission.emergency ? (
                        <td>
                            <span className="badge bg-danger">Emergency</span>
                        </td>
                    ) : (
                        <td>
                            <span className="badge ">&nbsp;</span>
                        </td>
                    )}
                    {submission.autoFile ? (
                        <td>
                            <span className="badge bg-primary">Autofile</span>
                        </td>
                    ) : (
                        <td>
                            <span className="badge ">&nbsp;</span>
                        </td>
                    )}
                    <td>
                        <div className="btn-group dropdown">
                            <a
                                href="#"
                                className="dropdown-toggle arrow-none btn btn-light btn-sm"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="mdi mdi-dots-horizontal"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => sync(submission.id!)}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Sync
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        shareCliqEfile(
                                            submission.id ?? APIModels.EmptyGuid
                                        );
                                    }}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Share eFile Url
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        shareCliqSubmissionStatus(
                                            submission.id ?? APIModels.EmptyGuid
                                        );
                                    }}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Share Submission Status
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        setLoading(true);
                                        checkDoubleFile(
                                            submission.id ?? APIModels.EmptyGuid
                                        );
                                    }}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Check Double File
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => hide(submission.id!)}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Hide
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        deleteEfmeSubmit(submission.id!)
                                    }
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Clear Submit Data
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => aiPopulate(submission.id!)}
                                >
                                    <i className="mdi mdi-robot-dead-outline me-2 text-muted font-18 vertical-middle"></i>
                                    Populate with AI
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        } else if (color === "red") {
            return (
                <tr style={{ background: "#fca9a9" }}>
                    <td>
                        {actionButton(
                            submission.id ?? "",
                            submission.statusDescription ?? ""
                        )}
                    </td>
                    <td>{submission.statusDescription}</td>
                    <td>{submission.legacyID || submission.id}</td>
                    <td>
                        {submission.filename}
                        <br />
                        {submission.statusReason}
                    </td>
                    <td>
                        {moment
                            .utc(submission.uploadedDateTime)
                            .local()
                            .format("MMMM Do YYYY, h:mm:ss a")}
                    </td>
                    {submission.emergency ? (
                        <td>
                            <span className="badge bg-danfer">Emergency</span>
                        </td>
                    ) : (
                        <td>
                            <span className="badge ">&nbsp;</span>
                        </td>
                    )}
                    {submission.autoFile ? (
                        <td>
                            <span className="badge bg-primary">Autofile</span>
                        </td>
                    ) : (
                        <td>
                            <span className="badge">&nbsp;</span>
                        </td>
                    )}
                    <td>
                        <div className="btn-group dropdown">
                            <a
                                href="#"
                                className="dropdown-toggle arrow-none btn btn-light btn-sm"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="mdi mdi-dots-horizontal"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => sync(submission.id!)}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Sync
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        shareCliqEfile(
                                            submission.id ?? APIModels.EmptyGuid
                                        );
                                    }}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Share eFile Url
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        shareCliqSubmissionStatus(
                                            submission.id ?? APIModels.EmptyGuid
                                        );
                                    }}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Share Submission Status
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        setLoading(true);
                                        checkDoubleFile(
                                            submission.id ?? APIModels.EmptyGuid
                                        );
                                    }}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Check Double File
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => hide(submission.id!)}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Hide
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        deleteEfmeSubmit(submission.id!)
                                    }
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Clear Submit Data
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => aiPopulate(submission.id!)}
                                >
                                    <i className="mdi mdi-robot-dead-outline me-2 text-muted font-18 vertical-middle"></i>
                                    Populate with AI
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        } else {
            return (
                <tr>
                    <td>
                        {actionButton(
                            submission.id ?? "",
                            submission.statusDescription ?? ""
                        )}
                    </td>
                    <td>{submission.statusDescription}</td>
                    <td>{submission.legacyID || submission.id}</td>
                    <td>
                        {submission.filename}
                        <br />
                        {submission.statusReason}
                    </td>
                    <td>
                        {moment
                            .utc(submission.uploadedDateTime)
                            .local()
                            .format("MMMM Do YYYY, h:mm:ss a")}
                    </td>
                    {submission.emergency ? (
                        <td>
                            <span className="badge bg-danger">Autofile</span>
                        </td>
                    ) : (
                        <td>
                            <span className="badge ">&nbsp;</span>
                        </td>
                    )}
                    {submission.autoFile ? (
                        <td>
                            <span className="badge bg-primary">Autofile</span>
                        </td>
                    ) : (
                        <td>
                            <span className="badge ">&nbsp;</span>
                        </td>
                    )}
                    <td>
                        <div className="btn-group dropdown">
                            <a
                                href="#"
                                className="dropdown-toggle arrow-none btn btn-light btn-sm"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="mdi mdi-dots-horizontal"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => sync(submission.id!)}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Sync
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        setLoading(true);
                                        checkDoubleFile(
                                            submission.id ?? APIModels.EmptyGuid
                                        );
                                    }}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Check Double File
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        shareCliqEfile(
                                            submission.id ?? APIModels.EmptyGuid
                                        );
                                    }}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Share eFile Url
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        shareCliqSubmissionStatus(
                                            submission.id ?? APIModels.EmptyGuid
                                        );
                                    }}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Share Submission Status
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => hide(submission.id!)}
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Hide
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        deleteEfmeSubmit(submission.id!)
                                    }
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Clear Submit Data
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => aiPopulate(submission.id!)}
                                >
                                    <i className="mdi mdi-robot-dead-outline me-2 text-muted font-18 vertical-middle"></i>
                                    Populate with AI
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        }
    };

    const [status, setStatus] = useState<DoubleFileStatus>(
        {} as DoubleFileStatus
    );
    const [loading, setLoading] = useState<boolean>();
    const [showModal, setShowModal] = useState<boolean>(false);

    useEffect(() => {
        // XXX(Brett): THIS NEEDS TO BE UNDEFINED WE WANT REASON TO BE NULL OR ELSE THE
        // SUBMISSION WAS ALREADY FILED
        console.log({
            showModal: showModal,
            status: JSON.stringify(status),
            default: JSON.stringify({} as DoubleFileStatus),
            total:
                !showModal &&
                JSON.stringify(status) !==
                    JSON.stringify({} as DoubleFileStatus),
        });
        if (!showModal) {
            setLoading(false);
            setShowModal(
                JSON.stringify(status) !==
                    JSON.stringify({} as DoubleFileStatus)
            );
        }
    }, [status]);

    return (
        <>
            <GenericModal
                title={`Checking if ${submission.filename} Double Filed`}
                show={loading ?? false}
                onClose={() => {
                    console.log("Loading Double File Check");
                    if (!showModal) {
                        setLoading(false);
                        setShowModal(
                            JSON.stringify(status) !==
                                JSON.stringify({} as DoubleFileStatus)
                        );
                    }
                }}
            >
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </GenericModal>
            <GenericModal
                title={`Double File Status of ${submission.filename}`}
                show={showModal}
                onClose={() => setShowModal(false)}
            >
                <textarea
                    className="col-12"
                    value={JSON.stringify(status, null, 4)}
                />
            </GenericModal>
            <ColoredRow color={color} />
        </>
    );
}

const checkDoubleFileLog = (
    submissionId: string | null,
    submissionDetailedResponse: DoubleFileStatusDetailedResponse | null
) => {
    return submissionId === null &&
        submissionDetailedResponse !== null &&
        typeof submissionDetailedResponse ===
            typeof DoubleFileStatusDetailedResponse
        ? console.log({
              checkDoubleFile: {
                  submissionResponse: { ...submissionDetailedResponse },
              },
          })
        : console.log({
              checkDoubleFile: {
                  submissionId: submissionId,
              },
          });
};
